import {SxType} from "@baseTypes/sx/sxTypes";

export const sx:SxType = {
    root:{
        overflow:'hidden'
    }
}